<header
    class="top-0 right-0 left-0 z-10 fixed flex items-center gap-8 bg-white dark:bg-gray-800 py-0 pr-4 dark:border-gray-200 border-b border-b-gray-200"
>
    <div class="items-center grid grid-cols-[200px_1fr_1fr] w-full">
        <div
            class="flex justify-center items-center py-4 pr-4 border-r border-r-gray-200 dark:border-r-gray-700 w-full font-bold text-xl"
        >
            <app-logo [logoLight]="logoLight()" [logoDark]="logoDark()" />
        </div>

        <div class="flex items-center">
            <div class="pl-4">
                <h1 class="font-semibold text-gray-900 text-xl">{{ title() }}</h1>
                <p class="text-gray-600 text-sm">{{ subtitle() }}</p>
            </div>
            <div>
                <button
                    type="button"
                    class="md:invisible visible top-2 right-[85px] z-10 fixed pt-2 focus:outline-none md:w-[200px] text-gray-500 hover:text-gray-900 dark:hover:text-white dark:text-gray-400"
                    (click)="toggleMenu()"
                    (keydown.enter)="toggleMenu()"
                    aria-label="Open menu"
                >
                    <i class="material-icons"> menu </i>
                </button>
            </div>
        </div>
        <div class="relative ml-auto px-2 py-2">
            <app-menu />
        </div>
    </div>
</header>

<div class="sergio"></div>
